import React from "react";

import { css } from "@emotion/css";
import CoreValuesTitle from "../../../img/svg/about/core-values.svg";
import CoreValuesMTitle from "../../../img/svg/about/core-values-m.svg";
import BG from "../../../img/jpg/about/values/bg.jpg";
import Sunny from "../../../img/svg/about/sunny.svg";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useIsMobile } from "../../../components/helpers/ScreenCheck";
import buttons from "../../../styles/buttons";
import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n";

const values = [
  {
    title: "Identity over influence",
    description: `Your image identity doesn’t reset every time fashion does. Your archetype gives you a reference point, so trends, aesthetics and other people’s style can influence your choices without defining them.`,
  },
  {
    title: "Structure over trends",
    description: `Trends change. Your structure is what you bring to every one of them. We start with the way you’re built and what works with your body, not what’s popular this season.`,
  },
  {
    title: "Precision over guesswork",
    description: `We don’t ask you to guess what type you are or what style you feel like today. We analyse your proportions, colouring, structure and features, then show you what the pattern says.`,
  },
  {
    title: "Clarity over rules",
    description: `We don’t give you rules and tell you what to wear. We show you what a choice does, why it works or doesn’t, and what changes when you choose differently. Wear whatever you want. Just know what it’s doing.`,
  },
  {
    title: "Individuality over sameness",
    description: `The same answer shouldn’t apply to everyone. Your structure, colouring and archetype are uniquely yours, so your style should be built from you, not from a formula designed to make everyone look the same.`,
  },
  {
    title: "Honesty over hype",
    description: `We don’t sell you confidence. We give you information. We’ll tell you what works, what doesn’t and why. What you do with it is up to you.`,
  },
];

const Values = () => {
  const isMobile = useIsMobile(744);
  const { t } = useI18n();
  return (
    <div className={style.container}>
      <img
        src={isMobile ? CoreValuesMTitle : CoreValuesTitle}
        alt={t("about_values_title")}
        className="title"
      />
      <div className="wrapper">
        {Object.values(values).map((v, i) => {
          return (
            <div key={i} className={`v${i + 1}`}>
              <h5>{v.title}</h5>
              <p>{v.description}</p>
            </div>
          );
        })}
      </div>
      <div className="banner">
        <img src={Sunny} alt="" className="sunny" />
        <span className="text">
          <p>
            {t("about_values_body1")}
            <br />
            {t("about_values_body2")}
            <br />
            {t("about_values_body3")}
          </p>
        </span>
        <div>
            <Link
              className={`${buttons.primary} ${buttons.inter}`}
              style={{
                background: "#FF6AFF",
                color: "#fff",
                boxShadow: "5px 5px 0px 0px #EB3438",
              }}
              to={"/subscribe"}
            >
              {t("home_join_waitlist")}
            </Link>
          {/* <Clickable>
            <img src={AppStoreLogo} alt={t("about_alt_appstore")} className="app store" />
          </Clickable>
          <Clickable>
            <img
              src={GooglePlayLogo}
              alt={t("about_alt_googleplay")}
              className="google play"
            />
          </Clickable> */}
        </div>
      </div>
    </div>
  );
};

const style = {
  container: css({
    paddingTop: 345,
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    backgroundImage: `url(${BG})`,
    backgroundPositionY: "-100px",

    ".title": {
      width: 944.5,
      height: 685.756,
      marginBottom: 113,
    },
    ".banner": {
      borderRadius: 60,
      border: "1.3px solid #F8BCF1",
      background: "#FFD5FA",
      display: "flex",
      padding: 42,
      flexDirection: "row",
      alignItems: "center",
      position: "relative",
      justifyContent: "space-between",
      gap: 120,
      maxWidth: 1348,
      marginBottom: 20,
      marginLeft: 36,
      marginRight: 36,

      ".sunny": {
        width: 194.52,
        height: 160.691,
        transform: "rotate(8.414deg)",
        position: "absolute",
        top: "-123px",
        left: 0,
        right: 0,
        margin: "auto",
      },
      ".text": {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        alignItems: "center",
      },
      h3: {
        color: "#FF5EBE",
        fontFamily: "Syne",
        fontSize: 79.1,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "normal",
        marginRight: 50,
      },
      p: {
        color: "#FF5EBE",
        fontFamily: "Syne",
        fontSize: 40,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "126%",
        width: 480,
      },
      div: {
        borderRadius: 60,
        border: "1px solid #F8BCF1",
        background: "#DAFFF1",
        display: "flex",
        padding: "32px 28px 38px 28px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 20,

        img: {
          width: 225.146,
          height: 90,
        },
      },
    },
    ".wrapper": {
      display: "flex",
      justifyContent: "center",
      alignItems: "stretch",
      gap: 30,
      alignSelf: "stretch",
      flexWrap: "wrap",
      maxWidth: 1400,
      margin: "auto",
      marginBottom: 175,

      div: {
        display: "flex",
        padding: 42,
        flexDirection: "column",
        alignItems: "center",
        gap: 24,
        borderRadius: 60,
        border: "1.3px solid #F8BCF1",
        width: "22%",

        "&.v1": {
          background: "#E9CDFF",
        },
        "&.v2": {
          background: "#D3F2FF",
        },
        "&.v3": {
          background: "#DAFFF1",
        },
        "&.v4": {
          background: "#FFE7E7",
        },
        "&.v5": {
          background: "#FCF2FF",
        },
        "&.v6": {
          background: "#FFF8F2",
        },
        h5: {
          color: "#fff",
          textAlign: "center",
          fontFamily: "Syne",
          fontSize: 30.675,
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "99.585%",
          justifyContent: "center",
          alignItems: "center",
          gap: 39,
          alignSelf: "stretch",
          borderRadius: 34,
          border: "1.56px solid #FF6AFF",
          background: "#FF6AFF",
          boxShadow: "6.5px 6.5px 0px 0px #EB3438",
          height: 117,
          display: "flex",
        },
        p: {
          color: "#202122",
          fontFamily: "Inter",
          fontSize: 16,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "150%",
          padding: "20px",
          justifyContent: "center",
          alignItems: "center",
          gap: 39,
          borderRadius: 39,
          border: "1.3px solid rgba(255, 106, 255, 0.70)",
          background: "rgba(255, 106, 255, 0.10)",
          backdropFilter: "blur(15.860000610351562px)",
          opacity: 0.7,
        },
      },
    },
    [desktop]: {
      paddingTop: 168,
      ".title": {
        width: 656.142,
        height: 474.8,
      },
      ".banner": {
        maxWidth: 900,
        span: {
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          alignContent: "flex-start",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 30,
        },
        h3: {
          fontSize: 70,
          lineHeight: "76px",
          marginRight: 0,
        },
        p: {
          fontSize: 34,
          width: 400,
        },
        ".text": {
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          alignContent: "flex-start",
          justifyContent: "space-between",
          alignItems: "flex-start",
        },
      },
      ".wrapper": {
        marginBottom: 200,

        div: {
          h5: {
            fontSize: 30.675,
          },
          p: {
            fontSize: 16,
          },
        },
      },
    },
    [laptop]: {
      paddingTop: 379,
      backgroundSize: 1200,
      backgroundPositionY: "-20px",
      ".title": {
        width: 563.158,
        height: 341.007,
      },

      ".banner": {
        width: "auto",
        maxWidth: 670,
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 50,
        paddingTop: 100,
        paddingBottom: 100,

        ".sunny": {
          left: 200,
          width: 262.78,
          height: 217.079,
          top: -140,
        },
        ".text": {
          gap: 80,
        },
        h3: {
          fontSize: 90,
          lineHeight: "110px",
          maxWidth: 542,
        },
        p: {
          fontSize: 44,
          lineHeight: "55.44px",
          maxWidth: 542,
        },
        div: {
          maxWidth: 600,
          width: "100%",
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",

          img: {
            width: 269.417,
            height: 107.697,
          },
        },
      },
      ".wrapper": {
        background: "#ffe3f1",
        marginBottom: 100,
        paddingBottom: 100,
        paddingLeft: 30,
        paddingRight: 30,

        div: {
          gap: 20,
          padding: 36,
          flex: "1 0 35%",

          h5: {
            fontSize: 26,
            height: 103.327,
            lineHeight: "26px",
          },
          p: {
            fontSize: 14,
            padding: "20px",
            lineHeight: "21px",
          },
        },
      },
    },
    [tablet]: {
      paddingTop: 169,
      backgroundSize: 1200,
      backgroundColor: "#fff",
      alignItems: "stretch",

      ".title": {
        width: 381.486,
        height: 231.001,
      },

      ".banner": {
        width: "auto",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "flex-start",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 30,
        padding: 26,
        paddingTop: 80,
        gap: 0,
        marginLeft: 20,
        marginRight: 20,

        ".sunny": {
          left: 160,
          width: 131.39,
          height: 108.54,
          top: -80,
        },
        ".text": {
          marginBottom: 60,
        },
        h3: {
          fontSize: 60,
          lineHeight: "73px",
          width: "auto",
        },
        p: {
          fontSize: 22,
          lineHeight: "27px",
          width: "auto",
        },
        div: {
          flexWrap: "wrap",
          width: "auto",
          gap: 24,

          img: {
            width: 225,
            height: 90,
          },
        },
      },
      ".wrapper": {
        marginBottom: 60,
        paddingBottom: 60,
        backgroundColor: "unset",
        paddingLeft: 20,
        paddingRight: 20,

        div: {
          gap: 20,
          padding: 36,
          paddingLeft: 20,
          paddingRight: 20,
          flex: "1 0 80%",

          h5: {
            fontSize: 26,
            height: "auto",
            lineHeight: "26px",
            padding: 34,
            paddingLeft: 0,
            paddingRight: 0,
          },
          p: {
            fontSize: 14,
            padding: "20px",
            lineHeight: "21px",
            paddingLeft: 15,
            paddingRight: 15,
          },
        },
      },
    },
  }),
};

export default Values;
